<template>
  <single-group />
</template>

<script>
import SingleGroup from "@/components/3pl/Settings/UsersAndGroups/Groups/SingleGroup/index";
export default {
  components: {
    SingleGroup,
  },
};
</script>

<style></style>
